import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  AppContainerService,
  AppRightDrawerService,
  SideNavBarService,
} from '@mydocma/app-container';
import {
  MydocmaTaskModule,
  TaskFilterService,
  TaskSearchService,
  TaskViewService,
} from '@mydocma/task';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mydocma-pr-message-center',
  standalone: true,
  imports: [CommonModule, MydocmaTaskModule],
  templateUrl: './message-center.component.html',
  styleUrls: ['./message-center.component.scss'],
  providers: [TaskViewService, TaskFilterService, TaskSearchService],
})
export class MessageCenterComponent {
  constructor(
    private readonly appRightDrawerService: AppRightDrawerService,
    public appContainerService: AppContainerService,
    public readonly sideNavbarService: SideNavBarService,
    private readonly taskViewService: TaskViewService,
  ) {
    combineLatest([this.appContainerService.mobileView$, this.appRightDrawerService.isOpen])
      .pipe(untilDestroyed(this))
      .subscribe(([isMobile, isOpen]) => {
        this.sideNavbarService.barVisibility = !(isMobile && isOpen);
      });
  }

  onCloseClick() {
    this.appRightDrawerService.close();
  }
}
